const defaultInit = {
  watch: {
    // eslint-disable-next-line no-unused-vars
    async '$route' (to, from) {
      document.title = `${to.meta.title} - ${this.lang.meta.app_title}`
      if (this.login_data.logged) {
        let path = await this.$store.dispatch('router/getPath', to)
        let permission = (path ? await this.$store.dispatch('router/getPermission', path) : false)
        this.$store.dispatch('router/setPath', path)
        if (!permission) {
          this.$router.push({ name: 'home' }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
          this.$store.dispatch('snackBar', { type: 1, message: (path ? this.lang.snackbar.error.no_permission : this.lang.snackbar.error.no_page) })
        }
      }
      if (this.$refs.defaultScrollbar) this.$vuebar.refreshScrollbar(this.$refs.defaultScrollbar, { preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true })
    }
  },
  methods: {
    onResize () {
      this.$store.dispatch('setIsMobile', (window.innerWidth <= 768))
    }
  },
  created () {
    // if (location.host !== this.app_data.app_server) window.location.hostname = `${this.app_data.app_protocol}://${this.app_data.app_server}`
    //
    this.$store.dispatch('setInterface', { loading: true, overlay: true })
    setTimeout(function () { this.$store.dispatch('setInterface', { loading: false, overlay: false }) }.bind(this), 5000)
    //
    this.$store.dispatch('socket/connectSocket')
    //
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  }
}

export default defaultInit
